// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels, useSearchAndFilter } from 'utilities/hooks';

// Components
import BaseCard from './_common/baseCard.js';

// Icons
import { FiCalendar } from 'react-icons/fi';

const InitiativeOverviewStartEnd = ({ promptKey, forceOpen }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { label } = useLabels();
    const { filtered } = useSearchAndFilter({
        instanceName: 'initiatives',
    });

    // ///////////////////
    // REFS
    // ///////////////////

    // ///////////////////
    // DATA
    // ///////////////////

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            <BaseCard
                {...{
                    forceOpen,
                    title: label(
                        'AI_PromptTitle_Initiative_Overview_Start_End'
                    ),
                    description: label(
                        'AI_PromptDescription_Initiative_Overview_Start_End'
                    ),
                    relation: {
                        key: '',
                        id: '',
                        name: '',
                        type: '',
                    },
                    icon: FiCalendar,
                    promptKey,
                    systemPrompts: [
                        'When asked for a table, create a list',
                        'Do not include any general heading or other headings than the sections asked for.',
                        'Do not mention object keys like "Status__c" or anything with __c in them. You may refer but not include them.',
                        'Do not ask followup questions.',
                        'The answer you provide should be in unescaped html tags for immediate parsing.',
                        'No wrapping <div>. Use <p> tags for paragraphs and <strong> for bold text and headings.',
                    ],
                    promptDataGetter: () =>
                        JSON.stringify(
                            filtered.map(initiative => ({
                                name: initiative.Name,
                                startDate: initiative.Grant_Start_Date__c,
                                endDate: initiative.Grant_End_Date__c,
                                category: initiative.Category__c,
                            }))
                        ),
                }}
            />
        </>
    );
};

InitiativeOverviewStartEnd.propTypes = {
    promptKey: t.string.isRequired,
};

InitiativeOverviewStartEnd.defaultProps = {
    promptKey: '',
};

export default InitiativeOverviewStartEnd;
